import Login from "../views/login/login";
import NewPasswordPage from "../views/newPassword";
import RemindPassword from "../views/remindPassword";

import Dashboard from "../views/dashboard/index"
import Messages from "../views/messages";

//icons
import DashIcon  from "../assets/icons/dashboard.svg"
import DashboardHover  from "../assets/icons/dashboardHover.svg"
import TeamIcon from "../assets/icons/team.svg"
import TeamHoverIcon from "../assets/icons/team-hover.svg";
import ClientIcon  from "../assets/icons/man.svg"
import ClientHover from "../assets/icons/manHover.svg"
import PlansIcon from "../assets/icons/plans.svg";
import PlansHoverIcon from "../assets/icons/plans-hover.svg";
import MessageIcon from "../assets/icons/mail.svg";
import MessageHoverIcon from "../assets/icons/mailOrange.svg";
import ConfigurationIcon from "../assets/icons/gear.svg";
import ConfigurationIconHover from "../assets/icons/gearHover.svg";


var routes = [
  {
    path: "/login",
    name: "Login",
    layout: "/auth",
    component: Login,
    redirect: false,
  },

  {
    path: "/recovery",
    name: "Recuperar Senha",
    layout: "/auth",
    component: RemindPassword,
    redirect: false,
  },

  {
    path: "/reset_password",
    name: "Login",
    layout: "/auth",
    component: NewPasswordPage,
    redirect: false,
  },

  {
    id: "am1",
    path: "/dashboard",
    name: "Dashboard",
    icon: DashIcon,
    iconHover:DashboardHover,
    layout: "/admin",
    component: Dashboard,
    redirect: false,
  },
  
  {
    id: "am2",
    path: "/users",
    name: "Usuários",
    icon: TeamIcon,
    iconHover: TeamHoverIcon,
    layout: "/admin",
    redirect: true,
  },

  {
    id: "am3",
    path: "/clients",
    name: "Clientes",
    icon: ClientIcon,
    iconHover:ClientHover,
    layout: "/admin",
    redirect: false,
  },

  {
    id: "am4",
    path: "/plans",
    name: "Planos",
    icon: PlansIcon,
    iconHover: PlansHoverIcon,
    layout: "/admin",
    redirect: false,
  },

  {
    id: "am5",
    path: "/messages",
    name: "Mensagens",
    icon: MessageIcon,
    iconHover: MessageHoverIcon,
    component: Messages,
    layout: "/admin",
    redirect: false,
  },

  {
    id: "am6",
    path: "/configuration",
    name: "Configuração",
    icon: ConfigurationIcon,
    iconHover: ConfigurationIconHover,
    // component: Configuration,
    layout: "/admin",
    redirect: false,
  },
];

export default routes;